import * as actionTypes from './actionTypes';

export const storeKpiMaster = (list) => {
  return {
    type : actionTypes.STORE_KPI_MASTER_LIST,
    val : list
  }
}

export const storeMappingMaster = (list) => {
  return {
    type : actionTypes.STORE_MAPPING_MASTER_LIST,
    val : list
  }
}